import { createFileRoute } from "@tanstack/react-router";
import { SwapPage } from "../../features/swap/pages/swap-page";
import { prefetchSdkSwapMetadata } from "../../shared/utils/metadata-data";
import { prefetchSdkTokens } from "../../shared/utils/tokens-data";

export const Route = createFileRoute("/_layout/swap")({
  loader: () => {
    // Fire and forget with error handling
    prefetchSdkSwapMetadata().catch(console.warn);
    prefetchSdkTokens().catch(console.warn);
    return null; // resolves immediately; route can render
  },
  component: SwapPage,
});
